import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  success(message: string, duration: number = 3000): void {
    this.snackBar.open(message, 'OK', {
      duration,
      panelClass: ['success-snackbar'],
    });
  }

  error(message: string, duration: number = 3000): void {
    this.snackBar.open(message, 'Dismiss', {
      duration,
      panelClass: ['error-snackbar'],
    });
  }

  info(message: string, duration: number = 3000): void {
    this.snackBar.open(message, 'Got it', {
      duration,
      panelClass: ['info-snackbar'],
    });
  }
}
